"use client";

// src/label.tsx
import * as React2 from "react";
import { systemForwardRef as systemForwardRef2 } from "@stepstone-genesis/system";
import { Text } from "@stepstone-genesis/components-text";
import {
  useFormStateHandlerContext as useFormStateHandlerContext2,
  useFormStateHandler as useFormStateHandler2
} from "@stepstone-genesis/components-form-state-handler";
import { omitProps } from "@stepstone-genesis/utilities";

// src/indicator.tsx
import * as React from "react";
import {
  Base,
  systemForwardRef
} from "@stepstone-genesis/system";
import {
  useFormStateHandlerContext,
  useFormStateHandler
} from "@stepstone-genesis/components-form-state-handler";

// src/styles.ts
var label = {
  root: {
    display: "block",
    textAlign: "start",
    cursor: "pointer",
    _hidden: {
      display: "none"
    },
    _disabled: {
      cursor: "not-allowed"
    }
  }
};
var indicator = {
  root: {
    color: "colorGreyDark",
    marginLeft: "spaceXs",
    _invalid: {
      color: "colorStatusNegativeDefault"
    }
  }
};
var styles = {
  label: { root: label.root },
  indicator: { root: indicator.root }
};

// src/indicator.tsx
var FormRequiredIndicatorElement = systemForwardRef(function FormRequiredIndicatorElement2({ context, removeIndicator, requiredIndicator = "*", ...props }, ref) {
  if (removeIndicator || !(context == null ? void 0 : context.isRequired)) return null;
  const ctx = context == null ? void 0 : context.dataAttributes(props);
  const indicatorStyles = Object.assign(
    {},
    styles.indicator.root
  );
  return /* @__PURE__ */ React.createElement(
    Base,
    {
      as: "span",
      ref,
      __themeDefinition: "form-indicator",
      role: "presentation",
      __root: indicatorStyles,
      ...props,
      ...ctx
    },
    requiredIndicator
  );
});
var FormRequiredIndicatorNonContext = systemForwardRef(function FormRequiredIndicatorNonContext2(props, ref) {
  const nonContextFormStateHandler = useFormStateHandler(props);
  return /* @__PURE__ */ React.createElement(
    FormRequiredIndicatorElement,
    {
      context: nonContextFormStateHandler,
      ref,
      ...props
    }
  );
});
var FormRequiredIndicator = systemForwardRef(function FormRequiredIndicator2(props, ref) {
  const withinContextFormStateHandler = useFormStateHandlerContext();
  return withinContextFormStateHandler ? /* @__PURE__ */ React.createElement(
    FormRequiredIndicatorElement,
    {
      context: withinContextFormStateHandler,
      ref,
      ...props
    }
  ) : /* @__PURE__ */ React.createElement(FormRequiredIndicatorNonContext, { ref, ...props });
});

// src/label.tsx
var FormLabelElement = systemForwardRef2(
  function FormLabelElement2(props, ref) {
    const {
      context,
      children,
      isRequired,
      isInvalid,
      removeIndicator,
      requiredIndicator,
      size,
      ...rest
    } = props;
    const labelStyles = Object.assign({}, styles.label.root);
    const formLabelContext = context == null ? void 0 : context.formLabelProps(props, ref);
    return /* @__PURE__ */ React2.createElement(
      Text,
      {
        as: "label",
        __themeDefinition: "form-label",
        fontWeight: "fontWeightBold",
        __root: labelStyles,
        size,
        ...formLabelContext,
        ...rest
      },
      children,
      /* @__PURE__ */ React2.createElement(
        FormRequiredIndicator,
        {
          requiredIndicator,
          isInvalid: isInvalid || (context == null ? void 0 : context.isInvalid),
          isRequired: isRequired || (context == null ? void 0 : context.isRequired),
          removeIndicator
        }
      )
    );
  }
);
var FormElementNonContext = systemForwardRef2(function FormElementNonContext2(props, ref) {
  const nonContextFormStateHandler = useFormStateHandler2(props);
  const omittedProps = omitProps(props, "variant");
  return /* @__PURE__ */ React2.createElement(
    FormLabelElement,
    {
      context: nonContextFormStateHandler,
      ref,
      ...omittedProps
    }
  );
});
var FormLabel = systemForwardRef2(
  function FormLabel2(props, ref) {
    var _a;
    const withinContextFormStateHandler = useFormStateHandlerContext2();
    return withinContextFormStateHandler ? /* @__PURE__ */ React2.createElement(
      FormLabelElement,
      {
        context: withinContextFormStateHandler,
        ref,
        size: (_a = props.size) != null ? _a : withinContextFormStateHandler == null ? void 0 : withinContextFormStateHandler.size,
        ...props
      }
    ) : /* @__PURE__ */ React2.createElement(FormElementNonContext, { ref, ...props });
  }
);
export {
  FormLabel,
  FormRequiredIndicator
};
